import { render, staticRenderFns } from "./SupportUserTokenLogin.vue?vue&type=template&id=1b139d2e&"
import script from "./SupportUserTokenLogin.vue?vue&type=script&lang=ts&"
export * from "./SupportUserTokenLogin.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports